{
  "title": "Buddy",
  "placeholder": "Hier wohnt bald dein persönlicher Chat-Kumpel mit eigener Soul, Tamagotchi-Bee, Online-Radio und allerhand Spielereien.",
  "coming_soon": "Im Aufbau — Schritt 1 von vielen ist getan.",
  "waking_up": "Buddy wacht auf…",
  "just_woken_up": "🎉 Hallo! Ich bin frisch geschlüpft — schreib mir!",
  "empty_hint": "Sag was. Ich bin da.",
  "new_chat": "Neuer Chat",
  "load_older": "↑ {{count}} ältere Nachrichten laden",
  "saved": "Gespeichert",
  "cancel": "Verwerfen",
  "save": "Änderungen speichern",
  "settings": {
    "title": "Buddy-Einstellungen",
    "subtitle": "Persönlichkeit, Modelle, Fähigkeiten und Laufzeit deines persönlichen Buddys.",
    "sections": "Einstellungsbereiche",
    "back": "Zurück zum Buddy",
    "retry": "Erneut versuchen",
    "load_error": "Buddy-Einstellungen konnten nicht geladen werden.",
    "save_error": "Buddy-Einstellungen konnten nicht gespeichert werden.",
    "tab_identity": "Persönlichkeit",
    "tab_context": "Kontext",
    "tab_model": "Modelle",
    "tab_tools": "Tools & MCP",
    "tab_skills": "Skills",
    "tab_mail": "Postfach",
    "tab_advanced": "Erweitert",
    "tab_compaction": "Kompaktierung",
    "tab_extensions": "Extensions"
  },
  "identity": {
    "name_label": "Name",
    "character_label": "Aktueller Charakter",
    "language_label": "Sprache",
    "tone_label": "Ton",
    "lang_de": "Immer Deutsch",
    "lang_en": "Always English",
    "lang_auto": "Folgt dem User",
    "tone_casual": "Locker & direkt",
    "tone_professional": "Professionell",
    "tone_brief": "Kurz und knapp",
    "soul_active": "Soul aktiv: Für diesen Buddy gibt es Soul-Dateien, die den Charakter-Prompt komplett ersetzen. Charakter, Sprache, Ton und Kontext von dieser Seite wirken erst, wenn die Soul geleert ist (Agenten → Buddy → Soul)."
  },
  "context": {
    "label": "Was soll Buddy dauerhaft über dich wissen?",
    "placeholder": "Beispiel:\nIch arbeite hauptsächlich mit Python und TypeScript.\nMeine bevorzugte Sprache ist Deutsch.\nBei Änderungen an Produktionssystemen zuerst nachfragen.",
    "hint": "Dieser Kontext wird Buddy in jedem Chat mitgegeben.",
    "session_warning": "Eine Kontextänderung erzeugt einen neuen System-Prompt und startet deshalb eine neue Buddy-Session."
  },
  "model": {
    "primary": "Hauptmodell",
    "primary_hint": "Das Modell für normale Buddy-Antworten und Tool-Aufrufe.",
    "fallbacks": "Fallback-Modelle",
    "fallbacks_hint": "Werden in dieser Reihenfolge genutzt, wenn das Hauptmodell ausfällt.",
    "search_models": "Modelle durchsuchen…",
    "temperature": "Temperatur",
    "temperature_hint": "Niedriger ist deterministischer, höher kreativer.",
    "max_tokens": "Maximale Antwort-Tokens",
    "thinking_budget": "Thinking-Budget",
    "thinking_hint": "0 deaktiviert ein festes Thinking-Budget.",
    "reasoning_effort": "Reasoning-Aufwand",
    "effort_default": "Modellstandard",
    "effort_low": "Niedrig",
    "effort_medium": "Mittel",
    "effort_high": "Hoch",
    "effort_xhigh": "Sehr hoch",
    "effort_max": "Maximal",
    "effort_ultra": "Ultra",
    "effort_unsupported": "Dieses Modell kennt keine Denk-Tiefe."
  },
  "tools": {
    "active_count": "{{active}} von {{total}} Tools aktiv",
    "enable_all": "Alle verfügbaren an",
    "disable_all": "Alle aus",
    "search": "Toolname, Beschreibung oder Kategorie suchen…",
    "unavailable": "Nicht verfügbar",
    "unavailable_hint": "Dieses zugewiesene Tool ist auf diesem Server derzeit nicht geladen.",
    "other": "Sonstige",
    "no_description": "Keine Beschreibung verfügbar.",
    "no_results": "Keine passenden Tools gefunden.",
    "mcp_title": "MCP-Server",
    "mcp_hint": "Aktiviert die Werkzeuge der ausgewählten, zentral verwalteten MCP-Server für Buddy.",
    "no_mcp": "Keine MCP-Server eingerichtet.",
    "longterm_memory": "Langzeitgedächtnis",
    "longterm_hint": "Buddy darf frühere Sessions semantisch durchsuchen und Erinnerungen verwenden.",
    "confirm": "Tool-Bestätigung verlangen",
    "confirm_hint": "Sensible Tool-Aktionen müssen vor der Ausführung bestätigt werden."
  },
  "skills": {
    "scope_system": "System",
    "scope_user": "Benutzer",
    "scope_project": "Projekt",
    "scope_agent": "Buddy",
    "new": "Buddy-Skill anlegen",
    "edit": "Skill bearbeiten",
    "search": "Skills nach Name, Zweck oder Herkunft suchen…",
    "enabled": "Aktiv",
    "disabled": "Deaktiviert",
    "empty": "Keine passenden Skills gefunden.",
    "load_error": "Skills konnten nicht geladen werden."
  },
  "advanced": {
    "compact_model": "Compaction-Modell",
    "main_model": "Wie Hauptmodell ({{model}})",
    "threshold": "Compaction-Trigger: {{value}} %",
    "threshold_hint": "Niedriger kompaktieren bedeutet mehr Reserve, aber häufigere Zusammenfassungen.",
    "compact_tool_limit": "Tool-Ergebnisse in Compaction",
    "reserve_tokens": "Token-Reserve",
    "max_turns": "Maximale Turns vor Compaction",
    "max_turns_hint": "Leer verwendet den automatisch berechneten Wert.",
    "automatic": "Automatisch",
    "tool_result_max": "Live Tool-Result-Limit",
    "zero_unlimited": "0 bedeutet kein Limit.",
    "max_iterations": "Maximale Tool-Schleifen",
    "cache_ttl": "Prompt-Cache-TTL"
  },
  "left_panel": {
    "no_briefing": "Noch kein Briefing für heute.",
    "setup": "Einrichten →",
    "tokens_today": "Tokens heute",
    "active_sessions": "Aktive Sessions",
    "tool_calls": "Tool Calls",
    "server": "Server",
    "backend": "Backend",
    "backend_ok": "✓ OK",
    "backend_error": "✗ Fehler"
  },
  "briefing": { "open": "Offen", "went_well": "Gut", "went_badly": "Schlecht", "today": "Heute" },
  "boxes": { "extensions": "Anwendungen", "buddy_settings": "Buddy-Einstellungen", "zahnfee": "Zahnfee" },
  "mode": { "label": "Modus", "normal": "Normaler Buddy-Chat", "focus": "Fokus", "humor": "Humorvoll", "brief": "Kurze Antworten", "hint": "Gilt für diesen Chat ab der nächsten Nachricht.", "error": "Modus konnte nicht gespeichert werden." }
}
